import { startsWithIntervalSince } from "../computedProperties";
import { operatorsWithoutRHS } from "./render";
import { snakeCase } from "es-toolkit";
export const renderSQL = (rule)=>{
    const output = rule.conditions.map((condition)=>renderCondition(condition)).filter((condition)=>condition !== undefined).join(" " + rule.operator + " ");
    if (output === "") {
        return "true";
    }
    return output;
};
export const getColumns = (rule)=>{
    const columns = rule.conditions.map((condition)=>getColumnDefinition(condition.lhs, condition.rhs)).filter((condition)=>condition !== undefined).join(", ");
    return columns;
};
export const getColumnNames = (rule)=>{
    const columns = rule.conditions.map((condition)=>getColumnName(condition.lhs, condition.rhs)).filter((condition)=>condition !== undefined);
    return columns;
};
const renderCondition = (condition)=>{
    const lhs = renderLHS(condition.lhs, condition.rhs);
    const operator = renderOperator(condition.operator);
    const rhs = renderRHS(condition.operator, condition.rhs);
    if (lhs === undefined || operator === undefined || rhs === undefined) {
        return undefined;
    }
    return `${lhs} ${operator} ${rhs}`.trim();
};
const renderOperator = (operator)=>{
    switch(operator){
        case "t":
            return "= true";
        case "f":
            return "= false";
        case "eq":
            return "=";
        case "neq":
            return "<>";
        case "gt":
            return ">";
        case "gte":
            return ">=";
        case "lt":
            return "<";
        case "lte":
            return "<=";
        case "c":
            return "LIKE";
        case "null":
            return "IS NULL";
        case "nnull":
            return "IS NOT NULL";
    }
};
const renderLHS = (lhs, rhs)=>{
    if (lhs.value.startsWith("device.") || lhs.value.startsWith("device[")) {
        const v = extractKey(lhs.value);
        if (startsWithIntervalSince(v)) {
            return undefined;
        }
        if (v == "osVersion") {
            return "device_os_version";
        }
        if (v == "interfaceStyle") {
            return "device_interface_style";
        }
        return snakeCase(v);
    }
    if (lhs.value.startsWith("user.") || lhs.value.startsWith("user[") || lhs.value.startsWith("params.") || lhs.value.startsWith("params[")) {
        const v = extractKey(lhs.value);
        switch(rhs.type){
            case "string":
                return `JSONExtractString(properties,'${v}')`;
            case "number":
                return `JSONExtractInt(properties,'${v}')`;
            case "boolean":
                return `JSONExtractBool(properties,'${v}')`;
        }
    }
    return undefined;
};
const getColumnDefinition = (lhs, rhs)=>{
    const columnName = renderLHS(lhs, rhs);
    const alias = extractKey(lhs.value);
    if (columnName === undefined || alias === undefined) {
        return undefined;
    }
    return `${columnName} as "${alias}"`;
};
const getColumnName = (lhs, rhs)=>{
    const columnName = renderLHS(lhs, rhs);
    const alias = extractKey(lhs.value);
    if (columnName === undefined || alias === undefined) {
        return undefined;
    }
    return alias;
};
function extractKey(str) {
    if (str.startsWith("user.")) {
        return str.replace("user.", "");
    }
    if (str.startsWith("device.")) {
        return str.replace("device.", "");
    }
    if (str.startsWith("params.")) {
        return str.replace("params.", "");
    }
    if (str.startsWith("user[")) {
        const match = str.match(/user\[\s*['"]([^'"]+)['"]\s*\]/);
        return match ? match[1] : null;
    }
    if (str.startsWith("device[")) {
        const match = str.match(/device\[\s*['"]([^'"]+)['"]\s*\]/);
        return match ? match[1] : null;
    }
    if (str.startsWith("params[")) {
        const match = str.match(/params\[\s*['"]([^'"]+)['"]\s*\]/);
        return match ? match[1] : null;
    }
    return str;
}
const renderRHS = (operator, rhs)=>{
    if (operatorsWithoutRHS.includes(operator)) {
        return "";
    }
    switch(rhs.type){
        case "number":
            return rhs.value.toString();
        case "boolean":
            return rhs.value.toString();
        case "string":
            return operator == "c" ? `'%${rhs.value}%'` : `'${rhs.value}'`;
    }
    return undefined;
};
